/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        fontIcon='ofindo'
        icon='dashboard'
        title={intl.formatMessage({ id: 'DASHBOARD.TITLE' })}
      />

      <AsideMenuItem
        to='/places'
        title={intl.formatMessage({ id: 'PLACES' })}
        fontIcon='ofindo'
        icon='places'
      >
      </AsideMenuItem>

      <AsideMenuItemWithSub
        to='/events'
        title='Veranstaltungen'
        fontIcon='ofindo'
        icon='calendar'
      >
        <AsideMenuItem to='/events/overview' title={intl.formatMessage({ id: 'OVERVIEW' })} hasBullet={true} />
        <AsideMenuItem to='/events/share' title={intl.formatMessage({ id: 'SHAREEVENTS' })} hasBullet={true} />
        <AsideMenuItem to='/events/settings' title={intl.formatMessage({ id: 'SETTINGS' })} hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        to='/statistics/overview'
        title='Statistik'
        fontIcon='ofindo'
        icon='statistics'
      />

      <AsideMenuItemWithSub
        to='/apps/chat'
        title='Abrechnung'
        fontIcon='ofindo'
        icon='billing'
      >
        <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/private-chat' title={intl.formatMessage({ id: 'OVERVIEW' })} hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title={intl.formatMessage({ id: 'SETTINGS' })} hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        to='/user-management/team'
        title='Team'
        fontIcon='ofindo'
        icon='user'
      />
    </>
  )
}
